import { fetchAPI } from "./apiUtils";

export function confirmOrderDelivery(orderId, formData) {
  return fetchAPI(`api/v2/orders/${orderId}/confirm-delivery`, 'POST', formData);
}

export function submitOrderFeedback(orderId, data) {
  return fetchAPI(`api/v2/orders/${orderId}/order_feedback`, 'POST', data);
}
